"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPassword = exports.signIn = void 0;
const token_1 = require("../storage/token");
const md5_1 = require("../utils/md5");
const base_1 = require("./base");
const const_1 = require("./const");
const signIn = (email, password) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.post)(const_1.BASE_PATH + "/users/login", {
        email,
        password: (0, md5_1.generateMD5Hash)(password),
    }).then((res) => {
        const { token, status } = res;
        if (token && status === 0) {
            (0, token_1.saveToken)(token);
            return true;
        }
        throw new Error("Sign in failed");
    });
});
exports.signIn = signIn;
const resetPassword = (email) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.post)(const_1.BASE_PATH + "/users/reset-password", { email });
});
exports.resetPassword = resetPassword;
